(function(){
  angular.module('charts')
    .directive('dblMilestonesList', function() {
      return {
        restrict: 'E',
          scope: {
            dblMilestones: '=',
            student: '=edxStudent'
          },
          templateUrl: '/resources/charts/directives/milestones-list/dbl-milestones-list.directive.html',
          controller: [
            '$attrs',
            '$modal',
            '$scope',
            'authentication',
            'configuration',
            'dblLessonService',
            'dblIaplService',
            'edxStudentAlertsService',
            '$state',
            DblMilestonesListController
          ]
        };
    }
  );

  function DblMilestonesListController(
    $attrs,
    $modal,
    $scope,
    authentication,
    configuration,
    dblLessonService,
    dblIaplService,
    studentAlertsService,
    $state
  ) {

    // provide a top level element id to use when generating subelement ids
    $scope.elementId = $attrs.id !== undefined ? $attrs.id : 'DBL_MILESTONES_LIST';
    $scope.pdLocations = {};
    var topicsInAlertLoading = true;
    var topicsInAlert;

    $scope.getProficiencyStatus = getProficiencyStatus;

    _onInit();

    function _onInit() {
      if (_useNewAlerts()) {
        $scope.$watch('student', _loadAlerts);
      }
    }

    function getProficiencyStatus(milestone) {
      if (milestone.isLessonGroupCompletedActivity()) {
        return 'GROUP_PROFICIENT';
      } else if (milestone.isLessonGroupInProgressActivity()) {
        if (_useNewAlerts()) {
          if (topicsInAlertLoading && !topicsInAlert) {
            return ''; // Show nothing instead of showing in-progress and then replacing once alerts load
          } else if(topicsInAlert[milestone.dblStandard.name]) {
            return 'NEEDS_ATTENTION';
          } else {
            return 'IN_PROGRESS';
          }
        } else {
          return milestone.needsAttention ? 'NEEDS_ATTENTION' : 'IN_PROGRESS';
        }
      } else {
        return '';
      }
    }

    function _loadAlerts() {
      if ($state.params.districtId && $scope.student && $scope.student.id) {
        topicsInAlertLoading = true;
        studentAlertsService.loadCurrentStudentAlertsForStudent($state.params.districtId, $scope.student.id).then(function(studentAlerts){
          topicsInAlert = studentAlertsService.selectAlertDblTopicNames(studentAlerts);
        }).catch(function(){
          topicsInAlert = {};
        }).finally(function(){
          topicsInAlertLoading = false;
        });
      }
    }

    function _useNewAlerts() {
      return authentication.getCustomer().hasTag('INSIGHT_EFP') && configuration.isFeatureEnabled('alerts_efp_enabled');
    }

    $scope.getDemoLink = function (milestone) {
      return dblLessonService.getDemoLink(milestone.demoLessonName);
    };

    $scope.getLessonImage = function (milestone) {
      if (!milestone.dblStandard) {
        return '';
      }

      return dblLessonService.getImageForDblStandard(milestone.dblStandard.name);
    };

    $scope.getPDUrl = function (milestone) {
      var customer = authentication.getCustomer();
      if (customer.isGuardian()) {
        return null;
      }

      return _.isUndefined(milestone.dblStandard) ? null : $scope.pdLocations[milestone.dblStandard.name];
    };

    $scope.openMilestoneCompletedLetterModal = function (milestone) {
      var modal = $modal.open({
        templateUrl: 'resources/core/partials/milestone-completed-letter-modal.html',
        windowClass: 'milestone-completed-letter-modal',
        controller: 'MilestoneCompletedLetterModalController',
        resolve: {
          dblActivity: function () {
            return milestone;
          }
        }
      });
    };

    $scope.$watch('dblMilestones', function(newVal) {
      if (newVal) {
        retrievePdLocations(newVal);
      }
    });

    function retrievePdLocations(milestones) {
      var milestonesWithPDLink = _.filter(milestones, function(milestone){
        return !_.isUndefined(milestone.dblStandard) &&
          ('GROUP_PROFICIENT' !== $scope.getProficiencyStatus(milestone));
      });

      var lessonGroupNames = _.map(milestonesWithPDLink, function(milestone) {
        return milestone.dblStandard.name;
      });

      dblIaplService.retrievePdLocations(lessonGroupNames).then(function(locations) {
        $scope.pdLocations = locations;
      });
    }
  }

})();
